import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class ContactService {

    constructor(
        private http: HttpClient
    ) {

    }

    public refreshBank() {
        return this.http.get<any[]>('/contacts/BANK');
    }

    public refreshCrypto() {
        return this.http.get<any[]>('/contacts/CRYPTO');
    }

    public deleteContact(id: number) {
        return this.http.delete<any[]>('/contacts/' + id);
    }
}
